/* eslint-disable react/jsx-boolean-value */
// DragOverlayCabinet.js
import React, { useRef, useEffect, useState, useCallback } from 'react';
import {
  string, number, oneOfType, bool, func, shape, instanceOf
} from 'prop-types';
import { Cabinet } from '../Cabinet';
import { useCabinetStore } from '../../../../../store/ui';

export const DragOverlayCabinet = React.memo(({
  id, top, left, width, height, mirror, origin, itemId, spacerName, voidSpacer
}) => {

  return (
    <>
      <div>
        <Cabinet
          id={id}
          top={top}
          left={left}
          width={width}
          height={height}
          itemId={itemId}
          mirror={mirror}
          origin={origin}
          spacer={itemId > 0}
          spacerName={spacerName}
          border={true}
        />
      </div>
      {voidSpacer && (
        <div>
          <Cabinet
            id={id}
            top={voidSpacer.top}
            left={voidSpacer.left}
            width={voidSpacer.width}
            height={voidSpacer.height}
            itemId={voidSpacer.itemId}
            mirror={false}
            origin={voidSpacer.origin}
            spacer={false}
            spacerName={voidSpacer.name}
            border={true}
          />
        </div>
      )}
    </>
  );
});

DragOverlayCabinet.propTypes = {
  id: string.isRequired,
  left: oneOfType([string, number]),
  top: oneOfType([string, number]),
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  mirror: bool.isRequired,
  origin: shape({
    Column: number.isRequired,
    Row: number.isRequired,
    Width: number.isRequired,
    Height: number.isRequired
  }).isRequired,
  itemId: oneOfType([string, number]).isRequired,
  spacerName: string,
  voidSpacer: shape({})
};
DragOverlayCabinet.defaultProps = {
  spacerName: '',
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  voidSpacer: null
};
